module.exports = __webpack_public_path__ + "20260508d160511t/img/learning-cuate-icon.044b9169.png";